module.exports = __webpack_public_path__ + "img/35400.8bdfd7fc.jpg";